import React, { useEffect, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
// import { useNavigate } from "react-router-dom";

import {
	Button,
	// DinamicInput,
	DinamicInputWithSearchBar,
	Input,
	InputOdontograma,
	Select,
	Textarea,
} from "../../components/Form";
import { getAge } from "../../utils/age";
import { BiChevronDown, BiPlus } from "react-icons/bi";
import {
	LaboratoryTable,
	MedicineDosageTable,
	OdontogramaTable,
} from "../../components/Tables";
import { toast } from "react-hot-toast";
import MedicineDosageModal from "../../components/Modals/MedicineDosage";
import { FaFileDownload, FaSave } from "react-icons/fa";
import { HiOutlineCheckCircle } from "react-icons/hi";
import ThreeColumRow from "../../components/ThreeColumRow";
import TwoColumRow from "../../components/TwoColumRow";
import LaboratoryServiceModal from "../../components/Modals/LaboratoryServiceModal";
import { useDispatch, useSelector } from "react-redux";
import {
	getVisita,
	getVisitasByCitaId,
	updateVisita,
} from "../../redux/features/visitasSlice";
import { useForm } from "react-hook-form";
import ConfirmationAlert from "../../components/ConfirmationAlert";
import { Enfermedades } from "../../components/EnfermedadesCIE";
import {
	createReceta,
	deleteRecetaByVisitaId,
	getAllRecetas,
	getRecetasById,
} from "../../redux/features/recetaSlice";
import { pdf } from "@react-pdf/renderer";
import RecetaPdf from "../../pdf/RecetaPdf";
import OdontogramaPdf from "../../pdf/OdontogramaPdf";
import { saveAs } from "file-saver";
import {
	deleteEstudio,
	getAllEstudiosByCita,
	getEstudiosByCitaId,
} from "../../redux/features/estudiosSlice";
import OrdenPdf from "../../pdf/OrdenPdf";
import { RiDeleteBinLine } from "react-icons/ri";
import HistoriaPdf from "../../pdf/HistoriaPdf";

import {
	createOdontograma,
	getOdontogramaByCitaId,
	getAllOdontogramaByCita,
} from "../../redux/features/odontogramaSlice";

const lugaresAtencion = [
  {
    id: 0,
    name: 'Ninguno',
  },
  {
    id: 1,
    name: "Área Médica",
  },
  {
    id: 2,
    name: "Medical Center",
  },
  {
    id: 3,
    name: "CDLA (Clínica de Las Américas)",
  },
];

const OpcionesdolorBucal =[
  {
    id: 0,
    name: 'Ninguno',
  },
  {
    id: 1,
    name: "Izquierdo",
  },
  {
    id: 2,
    name: "Derecho",
  },
];

const OpcionesDesvioBucal = [
  {
    id: 0,
    name: 'Ninguno',
  },
  {
    id: 1,
    name: "Izquierdo",
  },
  {
    id: 2,
    name: "Derecho",
  },
];

const OpcionesRuidoArticularBucal = [
  {
    id: 0,
    name: 'Ninguno',
  },
  {
    id: 1,
    name: "Crepitacion",
  },
  {
    id: 2,
    name: "Chasquido",
  },
];

const OpcionesLuxacionBucal = [
  {
    id: 0,
    name: 'Ninguno',
  },
  {
    id: 1,
    name: "Derecho",
  },
  {
    id: 2,
    name: "Izquierdo",
  },
];

const OpcionesPerfilFacial = [
  {
    id: 0,
    name: 'Recto',
  },
  {
    id: 1,
    name: "Covexo",
  },
  {
    id: 2,
    name: "Cóncavo",
  },
];

const OpcionesPosturaLabial = [
  {
    id: 0,
    name: 'Cerrado',
  },
  {
    id: 1,
    name: "Entreabierto",
  },
  {
    id: 2,
    name: "Abierto",
  },
];

const OpcionesTipoRespiracion = [
  {
    id: 0,
    name: 'Nasal',
  },
  {
    id: 1,
    name: "Bucal",
  },
  {
    id: 2,
    name: "Mixta",
  },
];


const OpcionesAgmídalasPal = [
  {
    id: 0,
    name: 'Ninguno',
  },
  {
    id: 1,
    name: "Presente",
  },
  {
    id: 2,
    name: "Ausente",
  },
];


const OpcionesPlacaBacteriana = [
  {
    id: 0,
    name: 'No',
  },
  {
    id: 1,
    name: "Si",
  },
];

const OpcionesTartaro = [
  {
    id: 0,
    name: 'No',
  },
  {
    id: 1,
    name: "Si",
  },
];


const OpcionesSaliva = [
  {
    id: 0,
    name: 'Escasa',
  },
  {
    id: 1,
    name: "Abundante",
  },
  {
    id: 2,
    name: "Viscosa",
  },
  {
    id: 3,
    name: "Fluida",
  },
];


const OpcionesRelacionMolarDer = [
  {
    id: 0,
    name: 'Clase 1 ',
  },
  {
    id: 1,
    name: "Clase 2",
  },
  {
    id: 2,
    name: "Clase 3",
  },
];

const OpcionesRelacionMolarIzq = [
  {
    id: 0,
    name: 'Clase 1 ',
  },
  {
    id: 1,
    name: "Clase 2",
  },
  {
    id: 2,
    name: "Clase 3",
  },
];

const OpcionesRelacionCaninaDer = [
  {
    id: 0,
    name: 'Clase 1 ',
  },
  {
    id: 1,
    name: "Clase 2",
  },
  {
    id: 2,
    name: "Clase 3",
  },
];

const OpcionesRelacionCaninaIzq = [
  {
    id: 0,
    name: 'Clase 1 ',
  },
  {
    id: 1,
    name: "Clase 2",
  },
  {
    id: 2,
    name: "Clase 3",
  },
];

const piezasDentales = [
	{ id: 1, name: "18" },
	{ id: 2, name: "17" },
	{ id: 3, name: "16" },
	{ id: 4, name: "15" },
	{ id: 5, name: "14" },
	{ id: 6, name: "13" },
	{ id: 7, name: "12" },
	{ id: 8, name: "11" },
	{ id: 9, name: "21" },
	{ id: 10, name: "22" },
	{ id: 11, name: "23" },
	{ id: 12, name: "24" },
	{ id: 13, name: "35" },
	{ id: 14, name: "26" },
	{ id: 15, name: "27" },
	{ id: 16, name: "28" },
	{ id: 17, name: "38" },
	{ id: 18, name: "37" },
	{ id: 19, name: "36" },
	{ id: 20, name: "35" },
	{ id: 21, name: "34" },
	{ id: 22, name: "33" },
	{ id: 23, name: "32" },
	{ id: 24, name: "31" },
	{ id: 25, name: "41" },
	{ id: 26, name: "42" },
	{ id: 27, name: "43" },
	{ id: 28, name: "44" },
	{ id: 29, name: "45" },
	{ id: 30, name: "46" },
	{ id: 31, name: "47" },
	{ id: 32, name: "48" },
	{ id: 33, name: "55" },
	{ id: 34, name: "54" },
	{ id: 35, name: "53" },
	{ id: 36, name: "52" },
	{ id: 37, name: "51" },
	{ id: 38, name: "61" },
	{ id: 39, name: "62" },
	{ id: 40, name: "63" },
	{ id: 41, name: "64" },
	{ id: 42, name: "65" },
	{ id: 43, name: "75" },
	{ id: 44, name: "74" },
	{ id: 45, name: "73" },
	{ id: 46, name: "72" },
	{ id: 47, name: "71" },
	{ id: 48, name: "81" },
	{ id: 49, name: "82" },
	{ id: 50, name: "83" },
	{ id: 51, name: "84" },
	{ id: 52, name: "85" },
	{ id: 53, name: "OTROS TX" }
];

const diagnosticosOdontograma = [
	{ name: "Ninguno" },
	{ name: "caries" },
	{ name: "gingivitis" },
	{ name: "periodontitis" },
];

const tratamientos = [
	{ name: "Ninguno" },
	{ name: "implante", costo: 200 },
	{ name: "protesis", costo: 200 },
	{ name: "ortodoncia", costo: 300 },
];

function NewMedicalRecode({ cita, defaultTab }) {
	const [isOpen, setIsOpen] = useState(false);
	const [labOpen, setLabOpen] = useState(false);
	// const [motivo, setMotivo] = useState("");
	const [lugarAtencion, setLugarAtencion] = useState(lugaresAtencion[0]);
  
	const [dolorBucal, setDolorBucal] = useState(OpcionesdolorBucal[0]);
	const [DesvioBucal, setDesvioBucal] = useState(OpcionesDesvioBucal[0]);
	const [RuidoArticularBucal, setOpcionesRuidoArticularBucal] = useState(OpcionesRuidoArticularBucal[0]);
	const [LuxacionBucal, setOpcionesLuxacionBucal] = useState(OpcionesLuxacionBucal[0]);
	const [PerfilFacial, setOpcionesPerfilFacial] = useState(OpcionesPerfilFacial[0]);
	const [PosturaLabial, setOpcionesPosturaLabial]= useState(OpcionesPosturaLabial[0]);
	const [TipoRespiracion,setOpcionesTipoRespiracion] = useState(OpcionesTipoRespiracion[0]);
	const [AgmidalasPal ,setOpcionesAgmídalasPal ] = useState( OpcionesAgmídalasPal [0]);
	const [PlacaBacteriana,setOpcionesPlacaBacteriana ] = useState( OpcionesPlacaBacteriana [0]);
	const [Tartaro, setOpcionesTartaro]= useState( OpcionesTartaro[0]);
	const [ Saliva,setOpcionesSaliva ] = useState( OpcionesSaliva [0]);
	const [ RelacionMolarDer,setOpcionesRelacionMolarDer ] = useState( OpcionesRelacionMolarDer [0]);
	const [ RelacionMolarIzq ,setOpcionesRelacionMolarIzq ] = useState( OpcionesRelacionMolarIzq [0]);
	const [ RelacionCaninaDer ,setOpcionesRelacionCaninaDer ] = useState( OpcionesRelacionCaninaDer [0]);  
	const [ RelacionCaninaIzq ,setOpcionesRelacionCaninaIzq ] = useState( OpcionesRelacionCaninaIzq[0]);

	const [valueIMC, setValueIMC] = useState("Ingrese el peso y la altura.");
	const [diagnostico, setDiagnostico] = useState("");
	const [receta, setReceta] = useState([]);
	// const navigate = useNavigate();
	const dispatch = useDispatch();
	const visita = useSelector(getVisita);
	const recetasFromBack = useSelector(getAllRecetas);
	const estudios = useSelector(getAllEstudiosByCita);
  	const [activeTab, setActiveTab] = useState(defaultTab || (cita?.tipo_evento === "Analisis o Laboratorio" ? 2 : 0));


	// Odontograma //
	const odontogramas = useSelector(getAllOdontogramaByCita);
	const [piezaDental, setPiezaDental] = useState("");
	const [diagnosticoDental, setDiagnosticoDental] = useState("");
	const [tratamiento, setTratamiento] = useState("");
	// Costo total del odontograma
	const [totalOdontograma, setTotalOdontograma] = useState(0);
	const [costoOdontograma, setCostoOdontograma] = useState("");
	const [filteredData, setFilteredData] = useState([]);
	const [filteredDataDiagnostico, setFilteredDataDiagnostico] = useState([]);
	const [filteredDataPiezaDental, setFilteredDataPiezaDental] = useState([]);
	const [diagnosticoOdontograma, setDiagnosticoOdontograma] = useState([]);
	const [odontogramasData, setOdontogramasData] = useState([]);

	const handleChange = (e) => {
		setTratamiento(e.target.value);
		let filtered = tratamientos.filter((item) =>
			item.name.toLowerCase().includes(tratamiento.toLowerCase())
		);
		if (filtered.length > 10) filtered = filtered.slice(0, 10);

		if (tratamiento === 0) {
			setFilteredData(tratamientos.slice(0, 10));
		} else setFilteredData(filtered);
	};

	const handleChangeDiagnostico = (ev) => {
		setDiagnosticoDental(ev.target.value);
		let filteredDiagnostico = diagnosticosOdontograma.filter((item) =>
			item.name.toLowerCase().includes(diagnosticoDental.toLowerCase())
		);
		if (filteredDiagnostico.length > 10)
			filteredDiagnostico = filteredDiagnostico.slice(0, 10);

		if (diagnosticoDental.length === 0) {
			setFilteredDataDiagnostico(diagnosticosOdontograma.slice(0, 10));
		} else setFilteredDataDiagnostico(filteredDiagnostico);
	};

	const handleChangePiezaDental = (e) => {
		let filteredPiezaDental = piezasDentales.filter((item) =>
			item.name.toLowerCase().includes(piezaDental.trim().toLowerCase())
		);

		if (filteredPiezaDental.length > 10)
			filteredPiezaDental = filteredPiezaDental.slice(0, 10);

		if (e.target.value.length === 0) {
			setFilteredDataPiezaDental(piezasDentales.slice(0, 10));
		} else setFilteredDataPiezaDental(filteredPiezaDental);

		setFilteredDataPiezaDental(filteredPiezaDental);
		setPiezaDental(e.target.value);
	};

	useEffect(() => {
		let filteredPiezaDental = piezasDentales.filter((item) =>
			item.name.toLowerCase().includes(piezaDental.trim().toLowerCase())
		);

		piezaDental?.length > 0 && setFilteredDataPiezaDental(filteredPiezaDental);

	}, [piezaDental]);

	const handleChangeCosto = (e) => {
		setCostoOdontograma(e.target.value);
	};


	const handleChangeTotal = (value) => {
		setTotalOdontograma(value);
	};

	//const {data: estudios, isLoading, error } = useEstudiosCita(cita?.id);

	const {
		register,
		handleSubmit,
		setValue,
		getValues,
		watch,
		reset,
		formState: { errors },
	} = useForm();

	useEffect(() => {
		if (cita?.id) {
			dispatch(getVisitasByCitaId(cita?.id));
			dispatch(getEstudiosByCitaId(cita?.id));
			dispatch(getOdontogramaByCitaId(cita?.id));
		}
	}, [cita?.id]);

	useEffect(() => {
		if (visita?.id) {
			dispatch(getRecetasById(visita.id));
			if (visita?.motivo) {
				setValue("motivo", visita.motivo);
			}
			setDiagnostico(visita.diagnostico);
			if (visita.lugar_atencion)
				setLugarAtencion(
					lugaresAtencion.find((lugar) => lugar.name === visita.lugar_atencion)
				);
      
      setDiagnostico(visita.diagnostico);
      if (visita.dolorBucal)
        setDolorBucal(
          OpcionesdolorBucal.find((dolorBucal) => dolorBucal.name === visita.dolorBucal)
        );

      setDiagnostico(visita.diagnostico);
      if (visita.DesvioBucal)
        setDesvioBucal(
          OpcionesDesvioBucal.find((DesvioBucal) => DesvioBucal.name === visita.DesvioBucal)
        );

      setDiagnostico(visita.diagnostico);
      if (visita.RuidoArticularBucal)
        setOpcionesRuidoArticularBucal(
          OpcionesRuidoArticularBucal.find((RuidoArticularBucal) => RuidoArticularBucal.name === visita.RuidoArticularBucal)
        );

      setDiagnostico(visita.diagnostico);
      if (visita.LuxacionBucal)
        setOpcionesLuxacionBucal(
          OpcionesLuxacionBucal.find((LuxacionBucal) => LuxacionBucal.name === visita.LuxacionBucal)
        );

      setDiagnostico(visita.diagnostico);
      if (visita.PerfilFacial)
        setOpcionesPerfilFacial(
          OpcionesPerfilFacial.find((PerfilFacial) => PerfilFacial.name === visita.PerfilFacial)
        ); 
            
      setDiagnostico(visita.diagnostico);
      if (visita.TipoRespiracion)
        setOpcionesTipoRespiracion(
          OpcionesTipoRespiracion.find((TipoRespiracion) => TipoRespiracion.name === visita.TipoRespiracion)
        ); 

      setDiagnostico(visita.diagnostico);
      if (visita.AgmidalasPal)
        setOpcionesAgmídalasPal(
          OpcionesAgmídalasPal.find((AgmidalasPal) => AgmidalasPal.name === visita.AgmidalasPal)
        ); 

      setDiagnostico(visita.diagnostico);
      if (visita.PlacaBacteriana)
        setOpcionesPlacaBacteriana(
          OpcionesPlacaBacteriana.find((PlacaBacteriana) => PlacaBacteriana.name === visita.PlacaBacteriana)
        ); 

      setDiagnostico(visita.diagnostico);
      if(visita.Tartaro)
        setOpcionesTartaro(
          OpcionesTartaro.find((Tartaro) => Tartaro.name === visita.Tartaro)
        );

      setDiagnostico(visita.diagnostico);
      if (visita.Saliva)
        setOpcionesSaliva(
          OpcionesSaliva.find((Saliva) => Saliva.name === visita.Saliva)
        ); 

      setDiagnostico(visita.diagnostico);
      if (visita.RelacionMolarIzq)
        setOpcionesRelacionMolarIzq(
          OpcionesRelacionMolarIzq.find((RelacionMolarIzq) => RelacionMolarIzq.name === visita.RelacionMolarIzq)
        ); 

      setDiagnostico(visita.diagnostico);
      if (visita.RelacionMolarDer)
        setOpcionesRelacionMolarDer(
          OpcionesRelacionMolarDer.find((RelacionMolarDer) => RelacionMolarDer.name === visita.RelacionMolarDer)
        ); 

      setDiagnostico(visita.diagnostico);
      if (visita.RelacionCaninaIzq)
        setOpcionesRelacionCaninaIzq(
          OpcionesRelacionCaninaIzq.find((RelacionCaninaIzq) => RelacionCaninaIzq.name === visita.RelacionCaninaIzq)
        ); 

      setDiagnostico(visita.diagnostico);
      if (visita.RelacionCaninaDer)
        setOpcionesRelacionCaninaDer(
          OpcionesRelacionCaninaDer.find((RelacionCaninaDer) => RelacionCaninaDer.name === visita.RelacionCaninaDer)
        ); 

			setValue("altura", visita?.altura);
			setValue("comentarios", visita?.comentarios);
			setValue("conducta", visita?.conducta);
			setValue("desglose_motivo", visita?.desglose_motivo);
			setValue("examen_fisico", visita?.examen_fisico);
			setValue("f_cardiaca", visita?.f_cardiaca);
			setValue("f_respiratoria", visita?.f_respiratoria);
			setValue("p_arterial_1", visita?.p_arterial_1);
			setValue("p_arterial_5", visita?.p_arterial_5);
			setValue("peso", visita?.peso);
			setValue("temperatura", visita?.temperatura);

      setValue("t_encias", visita.t_encias);
      setValue("t_mucosas", visita.t_mucosas);
      setValue("t_labios", visita.t_labios);
      setValue("t_lengua", visita.t_lengua);
      setValue("l_apertura",visita.l_apertura)
      setValue("t_paladar", visita.t_paladar);
      setValue("t_pisobucal",visita.t_pisobucal); 
      setValue("t_halitosis",visita.t_halitosis);

		}
	}, [visita?.id, recetasFromBack.length]);

	// PAra la ctualizacion de la variable odontogramasData y se modifique segun el backend
	useEffect(() => {
		if (odontogramas) {
			setOdontogramasData((prev) => {
				if (JSON.stringify(prev) !== JSON.stringify(odontogramas)) {
					return odontogramas;
				}
				return prev;
			});
		}
	}, [odontogramas]);

  
	const onSubmit = async (body) => {
		ConfirmationAlert({
			title: "Guardar Visita",
			text: `Estas seguro de guardar los datos de la visita?`,
			onAccept: async () => {
				body.id = visita?.id;
				body.diagnostico = diagnostico;
				body.lugar_atencion = lugarAtencion?.name;

				body.dolorBucal = dolorBucal?.name;
				body.DesvioBucal= DesvioBucal?.name;
				body.RuidoArticularBucal=RuidoArticularBucal?.name;
				body.LuxacionBucal=LuxacionBucal?.name;
				body.PerfilFacial= PerfilFacial?.name;
				body.PosturaLabial=PosturaLabial?.name;
				body.TipoRespiracion=TipoRespiracion?.name;
				body.AgmidalasPal=AgmidalasPal?.name;
				body.PlacaBacteriana=PlacaBacteriana?.name;
				body.Tartaro=Tartaro?.name;
				body.Saliva=Saliva?.name;
				body.RelacionMolarIzq=RelacionMolarIzq?.name;
				body.RelacionMolarDer=RelacionMolarDer?.name;
				body.RelacionCaninaIzq=RelacionCaninaIzq?.name;
				body.RelacionCaninaDer=RelacionCaninaDer?.name;

				const newData = await dispatch(updateVisita(body));
				if (newData?.error) {
					toast.error(
						`No se pudo guardar los datos de la visita: ${newData.error}`,
						{ duration: 5000 }
					);
				} else {
					toast.success("Datos de visita guardados con exito!", {
						duration: 5000,
					});
					window.location.reload();
					//navigate(0);
				}
			},
		});
	};

	const handleIMC = () => {
		const pesoF = getValues("peso");
		const alturaF = getValues("altura");
		if (pesoF > 0 && alturaF > 0) {
			const IMC = Number.parseFloat(
				pesoF / (((alturaF / 100) * alturaF) / 100)
			).toFixed(2);
			if (IMC < 18.5) setValueIMC(`${IMC} - Bajo Peso`);
			else if (IMC < 25) setValueIMC(`${IMC} - Peso Saludable`);
			else if (IMC < 30) setValueIMC(`${IMC} - Sobrepeso`);
			else setValueIMC(`${IMC} - Obesidad`);
		} else {
			setValueIMC("Ingrese el peso y la altura.");
		}
	};

	const handlePdfReceta = async () => {
		if (receta.length === 0 && recetasFromBack?.length === 0) {
			toast.error("Agregue elementos a la receta!", { duration: 5000 });
			return;
		}
		if (recetasFromBack?.length === 0) {
			ConfirmationAlert({
				title: "Generar Receta",
				text: `Estas seguro de generar la receta? Ya no podra editar despues de generar la receta.`,
				onAccept: async () => {
					const datosReceta = {
						visita_id: visita?.id,
						recetas: receta,
					};
					const newData = await dispatch(createReceta(datosReceta));
					if (newData?.error) {
						toast.error(`No se pudo generar la receta: ${newData.error}`, {
							duration: 5000,
						});
						return;
					} else {
						dispatch(getRecetasById(visita?.id));
						toast.success("Receta generada con exito! Descargando . . .", {
							duration: 5000,
						});
						const blob = await pdf(
							<RecetaPdf
								data={{
									nombre: `${cita?.patient?.persona?.nombre} ${cita?.patient?.persona?.apellidos}`,
									edad: `${
										cita?.patient?.persona?.fecha_nacimiento
											? getAge(cita?.patient?.persona?.fecha_nacimiento) +
											  " años"
											: ""
									}`,
									fecha: new Date().toLocaleDateString("en-GB"),
									lugarAtencion:
										visita?.lugar_atencion ?? `${getValues("lugar_atencion")}`,
									seguro: `${cita?.patient?.empresa_seg ?? ""}`,
									recetas: receta,
								}}
							/>
						).toBlob();
						saveAs(
							blob,
							`Receta-${visita.id}-${new Date().toLocaleDateString(
								"en-GB"
							)}.pdf`
						);
					}
				},
			});
		} else {
			const blob = await pdf(
				<RecetaPdf
					data={{
						nombre: `${cita?.patient?.persona?.nombre} ${cita?.patient?.persona?.apellidos}`,
						edad: `${
							cita?.patient?.persona?.fecha_nacimiento
								? getAge(new Date(cita?.patient?.persona?.fecha_nacimiento)) +
								  " años"
								: ""
						}`,
						fecha: new Date().toLocaleDateString("en-GB"),
						lugarAtencion:
							visita?.lugar_atencion ?? `${getValues("lugar_atencion")}`,
						seguro: `${cita?.patient?.empresa_seg ?? ""}`,
						recetas: recetasFromBack,
					}}
				/>
			).toBlob();
			saveAs(
				blob,
				`Receta-${visita.id}-${new Date().toLocaleDateString("en-GB")}.pdf`
			);
		}
	};

	const deleteReceta = () => {
		ConfirmationAlert({
			title: "Eliminar Receta",
			text: `Estas seguro de eliminar la receta? Ya no podra recuperar la informacion despues de eliminar la receta.`,
			onAccept: async () => {
				const newData = await dispatch(deleteRecetaByVisitaId(visita?.id));
				if (newData?.error) {
					toast.error(`No se pudo elimar la receta: ${newData.error}`, {
						duration: 5000,
					});
					return;
				} else {
					setReceta([]);
					dispatch(getRecetasById(visita?.id));
					toast.success("Receta eliminada con exito!", {
						duration: 5000,
					});
				}
			},
		});
	};

	const handleImpresionIC = async () => {
		const blob = await pdf(
			<HistoriaPdf
				data={{
					patient: cita?.patient,
					visita,
					receta: recetasFromBack,
				}}
			/>
		).toBlob();
		saveAs(
			blob,
			`HC-${visita.id}-${new Date().toLocaleDateString("en-GB")}.pdf`
		);
	};

	const handleAgregarOdontograma = () => {
		// Al realizar el agregado de una pieza este debe ser unitario y marcarse solo la pieza seleccionada
		if (!piezaForm || !diagnosticoForm) {
			toast.error("Necesita al menos indicar la pieza dental y el diagnóstico!", {
			duration: 5000,
			});
			return;
		}

		if ( piezaForm?.length > 2 && !piezaForm?.toLowerCase().includes("tx") ) {
			toast.error(`Solo puede agregar un diente esta intentando agregar: ${piezaForm}!`, {
				duration: 5000,
			});
			return;
		}
		
		const alreadyExists = (existDiente) => {
			return (diagnosticoOdontograma.some((item) => item.diente === existDiente) ||
				   odontogramasData.some((item) => item.diente === existDiente));
		};

		const respaldoDientes = [
			{ number1:"15", number2: "55"},
			{ number1:"14", number2: "54"},
			{ number1:"13", number2: "53"},
			{ number1:"12", number2: "52"},
			{ number1:"11", number2: "51"},
			{ number1:"21", number2: "61"},
			{ number1:"22", number2: "62"},
			{ number1:"23", number2: "63"},
			{ number1:"24", number2: "64"},
			{ number1:"35", number2: "65"},
			{ number1:"35", number2: "75"},
			{ number1:"34", number2: "74"},
			{ number1:"33", number2: "73"},
			{ number1:"32", number2: "72"},
			{ number1:"31", number2: "71"},
			{ number1:"41", number2: "81"},
			{ number1:"42", number2: "82"},
			{ number1:"43", number2: "83"},
			{ number1:"44", number2: "84"},
			{ number1:"45", number2: "85"}];

		const alreadyExistsTuple = () => {
			const found_diente = respaldoDientes.find((diente) => diente.number1 === piezaDental || diente.number2 === piezaDental);
			if (!found_diente) {
				return null;
			}
			const send_diente = piezaDental === found_diente.number1 ? found_diente.number2 : found_diente.number1;
			return alreadyExists(send_diente) ? found_diente : null;
		};
			

		const updateOdontograma = () => {
			setDiagnosticoOdontograma((prev) => {
				const existResp = alreadyExistsTuple();
				if (existResp) {
				  return prev.map((item) => {
					if (item.diente === piezaForm || (item.diente === existResp.number1 || item.diente === existResp.number2)) {
						return {
							...item,
							diente: piezaForm,
							diagnostico: diagnosticoForm,
							tratamiento: tratamientoForm,
							costo: costoForm,
						};
					}
					return item;
				  });
				}
			  
				return [
					...prev,
					{
						diente: piezaForm,
						diagnostico: diagnosticoForm,
						tratamiento: tratamientoForm,
						costo: costoForm,
					},
				];
			});
			  
		
			setOdontogramasData((prev) => {
				const existResp = alreadyExistsTuple(); 
				if (existResp) {
				  return prev.map((item) => {
					if (item.diente === piezaForm || (item.diente === existResp.number1 || item.diente === existResp.number2)) {
						return {
							...item,
							diente: piezaForm,
							diagnostico: diagnosticoForm,
							tratamiento: tratamientoForm,
							costo: costoForm,
						};
					}
					return item;
				  });
				}
			  
				return [
					...prev,
					{
						diente: piezaForm,
						diagnostico: diagnosticoForm,
						tratamiento: tratamientoForm,
						costo: costoForm,
					},
				];
			});
		
			reset({ pieza: "", tratamiento: "", diagnostico: "", costo: "" });
		};

		if (alreadyExists(piezaForm) || alreadyExistsTuple) {
			const piezaShippFound = alreadyExistsTuple();
			ConfirmationAlert({
			title: `Pieza dental: ${piezaForm} ocupada`,
			text: `${ piezaShippFound ?  `Tiene la pieza ${piezaShippFound.number1 !== piezaForm ? `${piezaShippFound.number1} ocupada, ¿desea cambiarla por la pieza: ${piezaShippFound.number2}?` : `${piezaShippFound.number2} ocupada, ¿desea cambiarla por la pieza: ${piezaShippFound.number1}?` }` : "Tiene una pieza dental idéntica en lista, ¿desea modificarla?" }`,
			onAccept: updateOdontograma,
			});
			return;
		} else {
			updateOdontograma();
		}

		reset({ pieza: "", tratamiento: "", diagnostico: "", costo: "" });
	}; 

	const piezaForm = watch("pieza");
	const diagnosticoForm = watch("diagnostico");
	const tratamientoForm = watch("tratamiento");
	const costoForm = watch("costo");
	const tratamientoEscogido = watch("tratamiento");

	useEffect(() => {
		const tratamiento = tratamientos.find(
			(t) => t.name === tratamientoEscogido
		);
		if (tratamiento) {
			setValue("costo", tratamiento.costo || "");
		}
	}, [tratamientoEscogido, setValue]);

	const deleteRecordByIndex = (index) => {
		setOdontogramasData((prevData) =>
			{	
				return prevData.filter((i) => !i?.diente.includes(index))
			}
		);
		setDiagnosticoOdontograma((prevData) =>
			{	
				return prevData.filter((i) => !i?.diente.includes(index))
			}
		);
	};

	const updateRecord = (id, updatedData, actualData) => {
		setDiagnosticoOdontograma(() => {
			const dataLocal = actualData.map((data) => 
				data.diente === updatedData.diente || data.odontograma_id === id? {
					...data,
					diagnostico: updatedData.diagnostico,
					tratamiento: updatedData.tratamiento,
					costo: updatedData.costo
				} : data
			);
			return dataLocal;
		});

		setOdontogramasData(() => {
			const dataLocal = actualData.map((data) => 
				data.diente === updatedData.diente || data.odontograma_id === id? {
					...data,
					diagnostico: updatedData.diagnostico,
					tratamiento: updatedData.tratamiento,
					costo: updatedData.costo
				} : data
			);
			return dataLocal;
		});
	};

	const handleCreateOdontograma = async () => {
		ConfirmationAlert({
			title: "Crear Odontograma",
			text: `Estas seguro de crear el odontograma?`,
			onAccept: async () => {
				if (odontogramasData?.length > 0) {
					const datosOdontograma = odontogramasData.map((item) => ({
						cita_id: cita?.id,
						diente: item.diente,
						diagnostico: item.diagnostico,
						tratamiento: item.tratamiento,
						costo: item.costo,
					}));
					const dataOdontogramaSend = {
						cita_id: cita?.id,
						odontogramas:JSON.stringify(datosOdontograma)
					};
					dispatch(createOdontograma(dataOdontogramaSend));
					if (datosOdontograma?.error) {
						toast.error(
							`No se pudo crear el odontograma: ${datosOdontograma.error}`,
							{
								duration: 5000,
							}
						);
						return;
					} else {
						toast.success("Odontograma creado con exito!", {
							duration: 5000,
						});
					}
				} else {
					toast.error("Debe registrar al menos una pieza dental!", {
						duration: 5000,
					});
				}
			},
		});
	};

	const handlePdfOdontograma = async () => {
		ConfirmationAlert({
			title: "Generar Odontograma PDF",
			text: `Estas seguro de generar el odontograma PDF?`,
			onAccept: async () => {
				if (odontogramasData?.length > 0) {
					const blob = await pdf(
						<OdontogramaPdf
							nombre= {`${cita?.patient?.persona?.nombre} ${cita?.patient?.persona?.apellidos}`}
							edad= {`${ cita?.patient?.persona?.fecha_nacimiento ? getAge(cita?.patient?.persona?.fecha_nacimiento) + " años" : ""}`}
							fecha = {new Date().toLocaleDateString("en-GB")}
							lugarAtencion= {visita?.lugar_atencion ?? `${getValues("lugar_atencion")}`}
							seguro= {`${cita?.patient?.empresa_seg ?? "Ninguno"}`}
							odontogramasActuales= { diagnosticoOdontograma }
							odontogramasBackEnd= { odontogramasData }
							costoOdontograma = { totalOdontograma }
						/>
					).toBlob();
					saveAs(
						blob,
						`Odontograma-${visita?.id}-${new Date().toLocaleDateString(
							"en-GB"
						)}.pdf`
					);
				} else {
					toast.error("Debe registrar al menos una pieza dental!", {
						duration: 5000,
					});
				}
			},
		});
	};
	  
	return (
		<>
			{
				// modal
				isOpen && (
					<MedicineDosageModal
						isOpen={isOpen}
						setReceta={setReceta}
						closeModal={() => {
							setIsOpen(false);
						}}
					/>
				)
			}
			{
				// modal
				labOpen && (
					<LaboratoryServiceModal
						isOpen={labOpen}
						closeModal={() => {
							setLabOpen(!labOpen);
						}}
						visita={visita}
					/>
				)
			}
			<Tabs className="border-border" selectedIndex={activeTab} onSelect={index => setActiveTab(index)} forceRenderTabPanel={true} defaultFocus={true}>
				<TabList>
					{cita?.tipo_evento !== "Analisis o Laboratorio" && (
						<>
							<Tab>Atención</Tab>
							<Tab>Recetas</Tab>
						</>
					)}
					<Tab>Análisis y Laboratorios</Tab>
					<Tab>Odontograma</Tab>
				</TabList>
				{cita?.tipo_evento !== "Analisis o Laboratorio" && (
					<>
						<TabPanel>
							{/* Atencion */}
							<div className=" grid grid-cols-12 gap-6 items-start">
								<div
									data-aos="fade-left"
									data-aos-duration="1000"
									data-aos-delay="100"
									data-aos-offset="200"
									className="col-span-12 lg:col-span-12 bg-white rounded-xl p-6"
								>
									<div className="flex w-full flex-col gap-5">
										<Button label="Imprimir HC" onClick={handleImpresionIC} />
										<div className="flex w-full flex-col gap-2">
											<p className="text-black text-sm">Lugar de Atención</p>
											<Select
												selectedPerson={lugarAtencion}
												setSelectedPerson={setLugarAtencion}
												datas={lugaresAtencion}
											>
												<div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
													{	
														lugarAtencion?.name
													}
													<BiChevronDown className="text-xl" />
												</div>
											</Select>
										</div>
										<Textarea
											label="Motivo de la consulta"
											color={true}
											rows={3}
											visible={true}
											placeholder={"Dolor..."}
											name="motivo"
											register={register("motivo")}
											setValue={setValue}
											getValue={getValues}
										/>
										{/* <Textarea
											label="Enfermedad Actual"
											color={true}
											rows={3}
											register={register("desglose_motivo")}
											name="desglose_motivo"
											setValue={setValue}
											getValue={getValues}
											placeholder={"Dolor abdominal y ...."}
										/> */}

										{/* Vital Signs */}
										<div className="border p-5 rounded-lg flex flex-col gap-3">
											<h2 className="mb-3">Examen Físico General</h2>
											<ThreeColumRow>
												<Input
													label="Frecuencia Cardiaca"
													color={true}
													type="number"
													register={register("f_cardiaca")}
													placeholder="0-200"
												/>
												<Input
													label="Presion Arterial 1'"
													color={true}
													type="text"
													register={register("p_arterial_1")}
													placeholder="40- 230/0-160"
												/>
												<Input
													label="Presion Arterial 5'"
													color={true}
													type="text"
													register={register("p_arterial_5")}
													placeholder="40- 230/0-160"
												/>
											</ThreeColumRow>
											<TwoColumRow>
												<Input
													label="Frecuencia Respiratoria"
													color={true}
													type="number"
													register={register("f_respiratoria")}
													placeholder="0-340"
												/>
												<Input
													label="Temperatura"
													color={true}
													type="number"
													register={register("temperatura")}
													placeholder="36"
												/>
											</TwoColumRow>
											<ThreeColumRow>
												<Input
													label="Peso"
													color={true}
													type="number"
													register={register("peso", { onChange: handleIMC })}
													placeholder="36 kg"
												/>
												<Input
													label="Altura"
													color={true}
													type="number"
													register={register("altura", { onChange: handleIMC })}
													placeholder="175cm"
												/>
												<div className="flex flex-col justify-center items-center ">
													<p>IMC</p>
													<p className="p-4 font-medium">{valueIMC}</p>
												</div>
												p
											</ThreeColumRow>
											<Textarea
												label="Examen Regional"
												color={true}
												rows={3}
												register={register("examen_fisico")}
												name="examen_fisico"
												setValue={setValue}
												getValue={getValues}
												placeholder={"Otros datos del examen físico, ...."}
											/>
										</div>

                    {/* Probando */}
                    <div className="border p-5 rounded-lg flex flex-col gap-3">
                      <h2 className="mb-3">Extra Bucal</h2>  
                      <TwoColumRow>
                        <div className="flex w-full flex-col gap-2">
                        <p className="text-black text-sm">Dolor Bucal</p>
                          <Select
                            selectedPerson={dolorBucal}
                            setSelectedPerson={setDolorBucal}
                            datas={OpcionesdolorBucal}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {dolorBucal?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>

                        <div className="flex w-full flex-col gap-2">
                        <p className="text-black text-sm">Desvío</p>
                          <Select
                            selectedPerson={DesvioBucal}
                            setSelectedPerson={setDesvioBucal}
                            datas={OpcionesDesvioBucal}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {DesvioBucal?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>
                      </TwoColumRow>

                      <TwoColumRow>
                        <Input
                          label="Limitacion de Apertura (mm)"
                          color={true}
                          type="number"
                          step="0.01"
                          register={register("l_apertura")}
                          placeholder="0.00"
                        />

                        <div className="flex w-full flex-col gap-2">
                        <p className="text-black text-sm">Ruido Articular</p>
                          <Select
                            selectedPerson={RuidoArticularBucal}
                            setSelectedPerson={setOpcionesRuidoArticularBucal}
                            datas={OpcionesRuidoArticularBucal}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {RuidoArticularBucal?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>
                      </TwoColumRow>

                      <TwoColumRow>
                        <div className="flex w-full flex-col gap-2">
                        <p className="text-black text-sm">Luxación</p>
                          <Select
                            selectedPerson={LuxacionBucal}
                            setSelectedPerson={setOpcionesLuxacionBucal}
                            datas={OpcionesLuxacionBucal}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {LuxacionBucal?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>

                        <div className="flex w-full flex-col gap-2">
                        <p className="text-black text-sm">Perfil Facial</p>
                          <Select
                            selectedPerson={PerfilFacial}
                            setSelectedPerson={setOpcionesPerfilFacial}
                            datas={OpcionesPerfilFacial}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {PerfilFacial?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>
                      </TwoColumRow>

                      <TwoColumRow>
                        <div className="flex w-full flex-col gap-2">
                        <p className="text-black text-sm">Postura Labial</p>
                          <Select
                            selectedPerson={PosturaLabial}
                            setSelectedPerson={setOpcionesPosturaLabial}
                            datas={OpcionesPosturaLabial}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {PosturaLabial?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>

                        <div className="flex w-full flex-col gap-2">
                        <p className="text-black text-sm">Respiración</p>
                          <Select
                            selectedPerson={TipoRespiracion}
                            setSelectedPerson={setOpcionesTipoRespiracion}
                            datas={OpcionesTipoRespiracion}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {TipoRespiracion?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>
                      </TwoColumRow>
                    </div>

                   
                    <div className="border p-5 rounded-lg flex flex-col gap-3">
                      <h2 className="mb-3">Examen de Boca</h2> 
                      <TwoColumRow>
                        <Input
                          label="Labios"
                          color={true}
                          type="Text"
                          register={register("t_labios")}
                        />

                        <Input
                          label="Lengua"
                          color={true}
                          type="text"
                          register={register("t_lengua")}
                        />
                      </TwoColumRow>

                      <Textarea
                      label="Encias"
                      color={true}
                      rows={3}
                      register={register("t_encias")}
                      name="t_encias"
                      setValue={setValue}
                      getValue={getValues}
                      placeholder={" "}
                      />

                      <Textarea
                        label="Mucosas"
                        color={true}
                        rows={3}
                        register={register("t_mucosas")}
                        name="t_mucosas"
                        setValue={setValue}
                        getValue={getValues}
                        placeholder={" "}
                      />

                      <TwoColumRow>
                        <Input
                          label="Paladar"
                          color={true}
                          type="text"
                          register={register("t_paladar")}
                        />
                        <Input
                          label="Piso Bucal"
                          color={true}
                          type="text"
                          register={register("t_pisobucal")}
                        />
                      </TwoColumRow>

                      <TwoColumRow>
                        <div className="flex w-full flex-col gap-2">
                        <p className="text-black text-sm">Agmídalas Palatinas</p>
                          <Select
                            selectedPerson={AgmidalasPal}
                            setSelectedPerson={setOpcionesAgmídalasPal}
                            datas={OpcionesAgmídalasPal}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {AgmidalasPal?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>

                        <Input
                          label="Halitosis"
                          color={true}
                          type="text"
                          register={register("t_halitosis")}
                        />
                      </TwoColumRow>

                      <ThreeColumRow>
                        <div className="flex w-full flex-col gap-2">
                        <p className="text-black text-sm">Placa Bacteriana</p>
                          <Select
                            selectedPerson={PlacaBacteriana}
                            setSelectedPerson={setOpcionesPlacaBacteriana}
                            datas={OpcionesPlacaBacteriana}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {PlacaBacteriana?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>

                        <div className="flex w-full flex-col gap-2">
                        <p className="text-black text-sm">Tártaro</p>
                          <Select
                            selectedPerson={Tartaro}
                            setSelectedPerson={setOpcionesTartaro}
                            datas={OpcionesTartaro}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {Tartaro?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>

                        <div className="flex w-full flex-col gap-2">
                        <p className="text-black text-sm">Saliva</p>
                          <Select
                            selectedPerson={Saliva}
                            setSelectedPerson={setOpcionesSaliva}
                            datas={OpcionesSaliva}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {Saliva?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>

                      </ThreeColumRow>

                      <TwoColumRow>
                        <div className="flex w-full flex-col gap-2">
                        <p className="text-black text-sm">Relacion Molar I</p>
                          <Select
                            selectedPerson={RelacionMolarIzq}
                            setSelectedPerson={setOpcionesRelacionMolarIzq}
                            datas={OpcionesRelacionMolarIzq}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {RelacionMolarIzq?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>

                        <div className="flex w-full flex-col gap-2">
                        <p className="text-black text-sm">Relacion Molar D</p>
                          <Select
                            selectedPerson={RelacionMolarDer}
                            setSelectedPerson={setOpcionesRelacionMolarDer}
                            datas={OpcionesRelacionMolarDer}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {RelacionMolarDer?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>

                      </TwoColumRow>

                      <TwoColumRow>
                        <div className="flex w-full flex-col gap-2">
                        <p className="text-black text-sm">Relacion Canina I</p>
                          <Select
                            selectedPerson={RelacionCaninaIzq}
                            setSelectedPerson={setOpcionesRelacionCaninaIzq}
                            datas={OpcionesRelacionCaninaIzq}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {RelacionCaninaIzq?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>

                        <div className="flex w-full flex-col gap-2">
                        <p className="text-black text-sm">Relacion Canina D</p>
                          <Select
                            selectedPerson={RelacionCaninaDer}
                            setSelectedPerson={setOpcionesRelacionCaninaDer}
                            datas={OpcionesRelacionCaninaDer}
                          >
                            <div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
                              {RelacionCaninaDer?.name}{" "}
                              <BiChevronDown className="text-xl" />
                            </div>
                          </Select>
                        </div>

                      </TwoColumRow>
                    </div>

                    {/* Probando Fin */}

										<DinamicInputWithSearchBar
											label="Diagnostico"
											color={true}
											rows={3}
											visible={true}
											datos={diagnostico}
											dataSearch={Enfermedades}
											setDatos={setDiagnostico}
											placeholder={"CIE-10..."}
										/>
										<Textarea
											label="Comentarios"
											color={true}
											rows={3}
											register={register("comentarios")}
											name="comentarios"
											setValue={setValue}
											getValue={getValues}
											placeholder={"Comentarios...."}
										/>
										<Textarea
											label="Conducta"
											color={true}
											rows={3}
											register={register("conducta")}
											name="conducta"
											setValue={setValue}
											getValue={getValues}
											placeholder={"Conducta ...."}
										/>
										<Button
											label={"Guardar"}
											Icon={HiOutlineCheckCircle}
											onClick={handleSubmit(onSubmit)}
										/>
									</div>
								</div>
							</div>
						</TabPanel>

						<TabPanel>
							{/* receta */}
							<div className=" grid grid-cols-12 gap-6 items-start">
								<div
									data-aos="fade-left"
									data-aos-duration="1000"
									data-aos-delay="100"
									data-aos-offset="200"
									className="col-span-12 lg:col-span-12 bg-white rounded-xl p-6"
								>
									<div>
										<div className="flex w-full flex-col gap-4 mb-6">
											<div className="flex justify-between items-center">
												<p className="text-black text-lg">Prescripción</p>
												<div className="flex gap-2">
													<button
														onClick={() => handlePdfReceta()}
														className="flex justify-center items-center bg-subMain rounded-lg text-white text-center text-2xl p-2"
													>
														<span className="text-sm mr-1">
															{recetasFromBack?.length > 0
																? "Imprimir "
																: "Generar PDF "}
														</span>{" "}
														<FaFileDownload />
													</button>
													{recetasFromBack?.length > 0 && (
														<button
															onClick={deleteReceta}
															className="bg-red-600 bg-opacity-5 text-red-600 rounded-lg border border-red-100 py-3 px-4 text-sm"
														>
															<RiDeleteBinLine />
														</button>
													)}
												</div>
											</div>
											<div className="w-full overflow-x-scroll">
												<MedicineDosageTable
													data={
														recetasFromBack.length > 0
															? recetasFromBack
															: receta
													}
													functions={{
														delete: (id) => {
															setReceta((state) =>
																state.filter((_, index) => index !== id)
															);
															toast.success("Elemento eliminado!");
														},
													}}
													button={true}
												/>
											</div>
											{recetasFromBack?.length === 0 && (
												<button
													onClick={() => {
														setIsOpen(true);
													}}
													className=" text-subMain flex-rows gap-2 rounded-lg border border-subMain border-dashed py-4 w-full text-sm"
												>
													<BiPlus /> Agregar Medicamento
												</button>
											)}
										</div>
									</div>
								</div>
							</div>
						</TabPanel>
					</>
				)}
				<TabPanel>
					{/* Analisis y laboratorios */}
					<div className=" grid grid-cols-12 gap-6 items-start">
						<div
							data-aos="fade-left"
							data-aos-duration="1000"
							data-aos-delay="100"
							data-aos-offset="200"
							className="col-span-12 lg:col-span-12 bg-white rounded-xl p-6"
						>
							<div>
								<div className="flex w-full flex-col gap-3">
									<div className="flex justify-between items-center">
										<p className="text-black text-lg">
											Análisis y Laboratorios
										</p>
										{/* <button className="flex justify-center items-center bg-subMain rounded-xl text-white text-center text-2xl p-2"> <FaFileDownload /> </button> */}
									</div>

									<div className="w-full overflow-x-scroll">
										<LaboratoryTable
											data={estudios}
											functions={{
												delete: (body) => {
													ConfirmationAlert({
														title: "Eliminar Orden",
														text: "Esta seguro de eliminar la orden?",
														onAccept: async () => {
															const res = await dispatch(deleteEstudio(body));
															if (res?.error) {
																toast.error(
																	"No se pudo eliminar la orden, " + res.error
																);
															} else {
																dispatch(getEstudiosByCitaId(cita?.id));
																toast.success("Orden eliminada correctamente!");
															}
														},
													});
												},
												printPdf: async (body) => {
													const blob = await pdf(
														<OrdenPdf
															data={{
																nombre: `${cita?.patient?.persona?.nombre} ${cita?.patient?.persona?.apellidos}`,
																edad: `${
																	cita?.patient?.persona?.fecha_nacimiento
																		? getAge(
																				new Date(
																					cita?.patient?.persona?.fecha_nacimiento
																				)
																		  ) + " años"
																		: ""
																}`,
																fecha: new Date().toLocaleDateString("en-GB"),
																lugarAtencion:
																	visita?.lugar_atencion ??
																	`${getValues("lugar_atencion")}`,
																seguro: `${cita?.patient?.empresa_seg ?? ""}`,
																orden: body,
															}}
														/>
													).toBlob();
													saveAs(
														blob,
														`Orden-${visita.id}-${new Date().toLocaleDateString(
															"en-GB"
														)}.pdf`
													);
												},
											}}
											button={true}
										/>
									</div>
									<button
										onClick={() => {
											setLabOpen(true);
										}}
										className=" text-subMain flex-rows gap-2 rounded-lg border border-subMain border-dashed py-4 w-full text-sm"
									>
										<BiPlus /> Agregar
									</button>
								</div>
							</div>
						</div>
					</div>
				</TabPanel>
				<TabPanel 

					forceRender={true}>
					
					{/* Odontograma */}
					<div className=" grid grid-cols-12 gap-6 items-start">
							<div
								data-aos="fade-left"
								data-aos-duration="1000"
								data-aos-delay="100"
								data-aos-offset="200"
								className="col-span-12 lg:col-span-12 bg-white rounded-xl p-6"
							>
								<div className="m-2">
									<p className="text-black text-lg ">Odontograma:</p>
								</div>
							{
								visita ?
								<div className="flex flex-col justify-around">
									<div className="flex items-center justify-center">
										<img
											className="h-auto max-w-full rounded-lg "
											alt="Odontograma"
											src="/odontograma.png"
										/>
									</div>
									<div className="col-span-5 lg:col-span-5 p-6">
										<div className="grid grid-cols-1 md:grid-cols-5 gap-3 items-start">
										
										{/* Pieza Dental */}
										<div>
											<InputOdontograma
												id="pieza"
												label="Pieza dental"
												color={true}
												register={register("pieza", {
													onChange: (e) => handleChangePiezaDental(e),
													onBlur: () => setFilteredDataPiezaDental([]),
													onMouseDown: (e) => handleChangePiezaDental(e),
												})}
												type={"text"}
												error={""}
											/>
											{filteredDataPiezaDental?.length > 0 && (
											<ul className="max-h-40 w-full border absolute rounded-lg z-50 bg-white overflow-y-scroll">
												{filteredDataPiezaDental?.map((item) => (
												<li
													key={item.id}
													onMouseDown={() => {
													setValue("pieza", item.name);
													setTimeout(setFilteredDataPiezaDental([]), 10);
													}}
													className="border-b py-2 px-5"
												>
													{`${item.name}`}
												</li>
												))}
											</ul>
											)}
										</div>

										{/* Diagnostico */}
										<div>
											<InputOdontograma
												label="Diagnostico"
												color={true}
												register={register("diagnostico", {
													onChange: (ev) => handleChangeDiagnostico(ev),
													onBlur: () => setFilteredDataDiagnostico([]),
													onMouseDown: (ev) => handleChangeDiagnostico(ev),
												})}
												type={"text"}
											/>
											{filteredDataDiagnostico?.length > 0 && (
											<ul className="max-h-40 w-full border absolute rounded-lg z-50 bg-white overflow-y-scroll">
												{filteredDataDiagnostico?.map((item) => (
												<li
													key={item.id}
													onMouseDown={() => {
													setValue("diagnostico", item.name);
													setTimeout(setFilteredDataDiagnostico([]), 400);
													}}
													className="border-b py-2 px-5"
												>
													{`${item.name}`}
												</li>
												))}
											</ul>
											)}
										</div>

										{/* Tratamiento */}
										<div>
											<InputOdontograma
												label="Tratamiento"
												color={true}
												register={register("tratamiento", {
													onChange: (e) => handleChange(e),
													onBlur: () => setFilteredData([]),
													onMouseDown: (e) => handleChange(e),
												})}
												type={"text"}
											/>
											{filteredData?.length > 0 && (
											<ul className="max-h-40 w-full border absolute rounded-lg z-50 bg-white overflow-y-scroll">
												{filteredData?.map((item) => (
												<li
													key={item.id}
													onMouseDown={() => {
													setValue("tratamiento", item.name);
													setTimeout(setFilteredData([]), 400);
													}}
													className="border-b py-2 px-5"
												>
													{`${item.name}`}
												</li>
												))}
											</ul>
											)}
										</div>

										{/* Costo */}
										<InputOdontograma
											label="Costo"
											color={true}
											register={register("costo", {
											onChange: (e) => handleChangeCosto(e),
											})}
											type={"text"}
											error={errors.costo}
										/>

										{/* Clasificador de edad para la tabla */}

										{/* <div className="flex w-full flex-col gap-3">
											<p className="text-black text-sm">Rango de edad</p>
											<Select
												selectedPerson={["Niño", "Adulto"]}
												setSelectedPerson={setAgeRating}
												datas={["Niño", "Adulto"]}
											>
												<div className="w-full flex-btn text-textGray text-sm p-4 border border-border font-light rounded-lg focus:border focus:border-subMain">
												{ageRating} <BiChevronDown className="text-xl" />
												</div>
											</Select>
										</div> */}

										{/* Botón Agregar */}
										<div className="mt-8">
											<Button onClick={handleAgregarOdontograma} Icon={BiPlus} label="Agregar" />
										</div>
									</div>

									<div>
										<div className="flex flex-col md:flex-row justify-between items-center mt-2">
											{/* Título */}
											<p className="text-black text-lg mb-4 md:mb-0">Resumen Odontograma</p>

											{/* Botones */}
											<div className="flex flex-row md:flex-row gap-2">
												<div>
												<button
													onClick={() => handleCreateOdontograma()}
													className="flex justify-center items-center bg-subMain rounded-lg text-white text-center text-2xl p-2"
												>
													<span className="text-sm mr-1">Guardar</span>
													<FaSave />
												</button>
												</div>

												<button
												onClick={() => handlePdfOdontograma()}
												className="flex justify-center items-center bg-subMain rounded-lg text-white text-center text-2xl p-2"
												>
												<span className="text-sm mr-1">Generar PDF</span>
												<FaFileDownload />
												</button>
											</div>
										</div>

										<div className="w-full overflow-x-scroll">
											<OdontogramaTable
												data={diagnosticoOdontograma}
												updateRecord={updateRecord}
												getOdontogramas={odontogramasData}
												functions={{
													delete: deleteRecordByIndex,
													total: handleChangeTotal
												}}
												button={true}
												// excludes_childs={excludes_childs}
											/>
										</div>
									</div>
									</div>
								</div>
								:
								<div className="absolute">
									Odontograma vacio, debe crear un odontograma para un paciente antes.
								</div>
							}
						</div>
					</div>
				</TabPanel>
			</Tabs>
		</>
	);
}

export default NewMedicalRecode;